import { render, staticRenderFns } from "./CVideoList.vue?vue&type=template&id=3a732477&scoped=true&"
import script from "./CVideoList.vue?vue&type=script&lang=js&"
export * from "./CVideoList.vue?vue&type=script&lang=js&"
import style0 from "./CVideoList.vue?vue&type=style&index=0&id=3a732477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a732477",
  null
  
)

export default component.exports